import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-time-config-view',
  standalone: true,
  templateUrl: './time-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
